import { Navigate, useParams } from "react-router-dom";
import { useInterviewFlowState } from "@/features/interviewFlow";

const STEP_ROUTES: Record<number, string> = {
  0: "",
  1: "p2",
};

interface StepGuardProps {
  children: React.ReactNode;
  requiredStep: number;
}

export function StepGuard({ children, requiredStep }: StepGuardProps) {
  const { step } = useInterviewFlowState();
  const { token } = useParams();

  if (step === null) return null;

  if (step !== requiredStep) {
    const subPath = STEP_ROUTES[step] ?? "";
    // Construct absolute path using the token to ensure correct redirection
    return <Navigate to={`/i/${token}/${subPath}`} replace />;
  }

  return <>{children}</>;
}
